import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registroApi } from '../api';
import { Logo } from '../components/Layout';

export default function Registro() {
  const [form, setForm] = useState({ nombre: '', apellido: '', username: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      const res = await registroApi(form);
      setExito(res.data.mensaje);
      setTimeout(() => navigate('/login'), 3000);
    } catch(err) {
      setError(err.response?.data?.error || 'Error al registrarse');
    } finally { setCargando(false); }
  };

  const inp = { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' };
  const lbl = { display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 6 };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(160deg, #0a2a4a 0%, #0d4a2a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Logo white />
          <p style={{ color: '#9ecfb8', fontSize: 13, marginTop: 8 }}>Soporte tecnico especializado en VUEPACS</p>
        </div>
        <div style={{ background: '#fff', borderRadius: 12, padding: '2rem' }}>
          <p style={{ fontSize: 20, fontWeight: 700, color: '#111', marginBottom: '1.5rem', textAlign: 'center' }}>Solicitar acceso</p>
          {exito ? (
            <div style={{ textAlign: 'center', padding: '1rem' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
              <p style={{ color: '#16a34a', fontSize: 14, lineHeight: 1.6 }}>{exito}</p>
              <p style={{ color: '#888', fontSize: 12, marginTop: 8 }}>Redirigiendo al login...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Nombre *</label>
                  <input type="text" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required style={inp}/>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Apellido *</label>
                  <input type="text" value={form.apellido} onChange={e => setForm({ ...form, apellido: e.target.value })} required style={inp}/>
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Usuario *</label>
                <input type="text" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required style={inp}/>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Email (@euroswiss.com.ar) *</label>
                <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required style={inp}/>
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={lbl}>Contrasena *</label>
                <input type="password" placeholder="••••••••" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required style={inp}/>
              </div>
              {error && <p style={{ color: '#e24b4a', fontSize: 13, marginBottom: 12 }}>{error}</p>}
              <button type="submit" disabled={cargando} style={{ width: '100%', padding: 12, background: '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
                {cargando ? 'Enviando...' : 'Solicitar acceso'}
              </button>
            </form>
          )}
          <p style={{ textAlign: 'center', fontSize: 13, color: '#888', marginTop: 16 }}>
            Ya tenes cuenta? <Link to="/login" style={{ color: '#1a6fbb', textDecoration: 'none', fontWeight: 500 }}>Iniciar sesion</Link>
          </p>
        </div>
      </div>
    </div>
  );
}